import { PollWithResults } from '@core/types';
import { SSPollResult } from '../SSPollResult';

interface Props {
    poll: PollWithResults;
}

export const SSPollResults = ({ poll: pollWithVotes }: Props) => {
    return (
        <ul className="w-full min-h-0 bg-white shadow-5xl overflow-y-auto overscroll-y-contain p-0" data-testid="PollResults">
            {pollWithVotes.options.map((option, index) => (
                <SSPollResult
                    key={`poll-result-${index}`}
                    index={index}
                    option={option}
                    totalVotes={pollWithVotes.totalWeightedVotes}
                    showPercentagesOnly={pollWithVotes.showPercentagesOnly}
                />
            ))}
        </ul>
    );
};
